import { GET_QMS_DASHBOARD_DATA } from "../../../constants";

export function getQMSDashboardData(data) {
    return {
        type: GET_QMS_DASHBOARD_DATA,
        data,
    };
}
